import { render, staticRenderFns } from "./AppearanceConfiguration.vue?vue&type=template&id=16b56f11&scoped=true&"
import script from "./AppearanceConfiguration.vue?vue&type=script&lang=ts&"
export * from "./AppearanceConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b56f11",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VDialog,VDivider,VForm,VImg,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b56f11')) {
      api.createRecord('16b56f11', component.options)
    } else {
      api.reload('16b56f11', component.options)
    }
    module.hot.accept("./AppearanceConfiguration.vue?vue&type=template&id=16b56f11&scoped=true&", function () {
      api.rerender('16b56f11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/policies/AppearanceConfiguration.vue"
export default component.exports